import DataTable from 'datatables.net-dt';

/**
 * Initialize table block.
 *
 * Ensure initial state is correct.
 *
 * @param {HTMLElement} blockElement Table block.
 */
const initTableBlock = ( blockElement ) => {
	const searchForm = document.querySelector( '.kaplan-table-salesforce__search' );
	if ( searchForm ) {
		searchForm.addEventListener( 'submit', handleSearch );
	}

	const agencyTermInput = document.querySelector( '.kaplan-table-salesforce__search__term' );
	if ( agencyTermInput ) {
		agencyTermInput.addEventListener( 'input', toggleSubmitButton );
	}

	new DataTable( blockElement, {
		autoWidth: false,
		searching: false,
		ordering: true,
		columnDefs: [
			{
				orderable: true,
				targets: [ 0, 1 ],
				orderData: [ 1, 0 ],
			},
		],
		columns: [
			{
				orderSequence: [ 'asc', 'desc' ],
				title: 'Agency name',
			},
			{
				orderSequence: [ 'asc', 'desc' ],
				title: 'Website URL',
			},
		],
		dom: '<"dt-top-container"f>rt<"dt-bottom-container"ilp><"clear">',
		language: {
			emptyTable: 'No results found',
			search: '',
		},
		lengthChange: false,
		pagingType: 'simple_numbers',
		initComplete: function () {
			const wrapper = document.createElement( 'div' );
			wrapper.className = 'dt-table-container';
			const dtContainer = blockElement.closest( '.dt-container' );
			dtContainer.insertBefore( wrapper, blockElement );
			wrapper.appendChild( blockElement );
		},
	} );
};

/**
 * Initialize the Search button.
 *
 * @param {Event} event Form submit event.
 */
function handleSearch( event ) {
	event.preventDefault();

	const agencyTemInput = document.querySelector( '.kaplan-table-salesforce__search__term' );

	// Check if the length of the agency input is less than 3 characters.
	if ( agencyTemInput.length < 3 ) {
		return;
	}

	hideErrorMessage();
	toggleLoadingImage();

	// Prepare the data to be sent in the POST request.
	let params = new URLSearchParams();
	params.append( 'action', 'search_agencies_by_name' );
	params.append( 'agency_name', agencyTemInput.value );
	params.append( '_ajax_nonce', window.search_agency_data['nonce'] );

	// Send the POST request using the Fetch API.
	fetch( window.search_agency_data['ajax_url'], {
		method: 'POST',
		body: params,
	} )
		.then( response => {
			toggleLoadingImage();
			clearTable();
			hideErrorMessage();

			return response.json();
		} )
		.then( body => {
			if ( body.success && Array.isArray( body.data ) ) {
				const formattedData = body.data.map( item => [
					item['Agency name'],
					item['Website URL'],
				] );
				refreshTable( formattedData );
			} else if ( body.success === false && body.data ) {
				throw new Error( body.data );
			} else {
				throw new Error( 'Network response was not ok' );
			}
		} )
		.catch( err => {
			showErrorMessage( err.message );
		} );
}

/**
 * Refreshes the data in a DataTable.
 *
 * @param {Array} newData - The new data to be populated into the DataTable.
 */
function refreshTable( newData ) {
	const table = new DataTable( document.querySelector( '.kaplan-table-salesforce__table' ) );
	table.rows.add( newData );
	table.draw();

	const parentTable = document.querySelector( '.kaplan-table-salesforce .wp-block-table' );
	parentTable.style.display = 'block';
}

/**
 * Clear the data in a DataTable.
 *
 */
function clearTable() {
	let table = new DataTable( document.querySelector( '.kaplan-table-salesforce__table' ) );
	table.clear().draw();
}

/**
 * Toggles the loading image.
 */
function toggleLoadingImage() {
	const loadingImage = document.querySelector( '.kaplan-table-salesforce__search__loading' );

	if ( loadingImage ) {
		// Check the current display status and toggle between 'none' and 'block'
		if ( loadingImage.style.display === 'none' || loadingImage.style.display === '' ) {
			loadingImage.style.display = 'block';
		} else {
			loadingImage.style.display = 'none';
		}
	}
}

/**
 * Function to enable or disable the submit button based on input length.
 */
function toggleSubmitButton() {
	const submitButton = document.querySelector( '.kaplan-table-salesforce__search .wp-block-button__link' );
	const agencyTemInput = document.querySelector( '.kaplan-table-salesforce__search__term' );

	if ( agencyTemInput.value.length >= 3 ) {
		submitButton.removeAttribute( 'disabled' );
	} else {
		submitButton.setAttribute( 'disabled', 'true' );
	}
}

/**
 * Show error message.
 *
 * @param {string} message The error message to display.
 */
function showErrorMessage( message ) {
	const errorDiv = document.querySelector( '.kaplan-table-salesforce__search-error' );
	if ( errorDiv ) {
		errorDiv.textContent = message;
		errorDiv.setAttribute( 'aria-hidden', 'false' );
		errorDiv.setAttribute( 'aria-live', 'assertive' );
		errorDiv.style.display = 'block';
	}
}

/**
 * Hide error message.
 */
function hideErrorMessage() {
	const errorDiv = document.querySelector( '.kaplan-table-salesforce__search-error' );
	if ( errorDiv ) {
		errorDiv.textContent = '';
		errorDiv.setAttribute( 'aria-hidden', 'true' );
		errorDiv.setAttribute( 'aria-live', 'polite' );
		errorDiv.style.display = 'none';
	}
}

/**
 * Kick it all off.
 */
function bootstrap() {
	document.querySelectorAll( '.kaplan-table-salesforce__table' )
		.forEach( el => initTableBlock( el ) );
}

document.addEventListener( 'DOMContentLoaded', bootstrap );
